import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store';
import { selectIsNavigationEnabled } from '../store/slices/navigationSlice';

// Custom hook that provides controlled navigation
export const useNavigationControl = () => {
  const navigate = useNavigate();
  const isNavigationEnabled = useAppSelector(selectIsNavigationEnabled);

  // Controlled navigate function that checks navigation state
  const controlledNavigate = useCallback(
    (to: string | number, options?: { replace?: boolean; state?: any }) => {
      // Only allow navigation if it's enabled
      if (isNavigationEnabled) {
        if (typeof to === 'string') {
          if (options) {
            navigate(to, options);
          } else {
            navigate(to);
          }
        } else {
          // Handle numeric navigation (go back/forward)
          navigate(to);
        }
      }
      // If navigation is disabled, silently do nothing (no visual feedback)
    },
    [navigate, isNavigationEnabled]
  );

  // Return the controlled navigation function and the current state
  return {
    navigate: controlledNavigate,
    isNavigationEnabled,
  };
};

export default useNavigationControl;
